export const getEmail = state => state.getIn(['resetPassword', 'email']);

export const getIsResending = state => state.getIn(['resetPassword', 'resending']);
